import styled from 'styled-components';
import Button from '@bit/twentyscoops.20scoops.paylo.components.button';

import Container from '@material-ui/core/Container';
import Box from '@material-ui/core/Box';
import { useTranslation } from 'react-i18next';
import { Dialog } from 'components/Dialog/dialog.component';
import Typography from '@material-ui/core/Typography';
import { useMemo, useState } from 'react';
import { SplitBillService } from 'services/split-bill-service';
import { SESSION } from 'constants/enum/session';
import { Item, IItem } from './item';
import AdaptButton from 'components/base/Button';
import { map, uniq } from 'lodash-es';

const Confirm = styled(AdaptButton)`
  && {
    font-weight: 700;
    margin-top: 16px;
    height: 56px;
  }
`;

const ButtonAdapter = styled(Button)`
  && {
    box-shadow: none;
    margin: 10px 0;
    min-width: auto;
    padding: 16px;
    span {
      text-decoration: none;
      font-weight: 700;
      font-size: 14px;
    }
    &.MuiButton-outlined {
      background: ${({ theme: { color } }) => color.white_500};
    }
  }
`;

interface Props {
  paymentInfo: {
    pid: string;
  };
}
export const PayOther = ({ paymentInfo }: Props) => {
  const { t } = useTranslation();
  const [items, setItems] = useState<IItem[]>([]);
  const [open, setOpen] = useState<boolean>(false);
  const [select, setSelect] = useState<IItem[]>([]);

  const splitBillService = useMemo(() => {
    return new SplitBillService();
  }, []);

  const onClick = () => {
    setOpen(true);
    const token = sessionStorage?.getItem(SESSION.HEAD_SPLIT_TOKEN) || '';
    splitBillService.getPayOtherItems(token).then((res) => setItems(res.data));
  };

  const onConfirm = () => {
    const token = sessionStorage?.getItem(SESSION.TOKEN) || '';

    const itemPids = map(uniq(select), (data) => data.pid);

    const payload = { currentSplitPid: paymentInfo.pid, itemPids };
    splitBillService.updatePayOtherItems(token, payload).then(() => {
      setOpen(false);
    });
  };

  return (
    <>
      <Dialog
        open={open}
        handleClose={() => {
          setOpen(false);
        }}
        dividers={false}
      >
        <Container>
          <Box>
            <Typography style={{ textAlign: 'left', marginBottom: '20px', marginTop: '20px' }}>
              {t('selectMenuItemDesc')}
            </Typography>

            {items.length > 0 ? (
              items.map((item: IItem) => (
                <Item item={item} selected={select.includes(item)} setSelect={setSelect} />
              ))
            ) : (
              <Typography>Waiting other pickup</Typography>
            )}
          </Box>
          <Box>
            <Confirm
              fullWidth
              paylo
              variant="contained"
              type="submit"
              loadingColor="#fff"
              onClick={() => onConfirm()}
              disabled={!select.length}
            >
              {t('confirmItems')}
            </Confirm>
          </Box>
        </Container>
      </Dialog>
      <Container maxWidth="xs">
        <Box px={2} py={2}>
          <ButtonAdapter
            fullWidth
            loadingColor="#2867B5"
            paylo
            paylobg="default"
            variant="outlined"
            onClick={() => onClick()}
          >
            {t('payOthers')}
          </ButtonAdapter>
        </Box>
      </Container>
    </>
  );
};
